import {
  ApplicationRef,
  ComponentRef,
  createComponent,
  effect,
  inject,
  Injectable,
  provideEnvironmentInitializer,
} from '@angular/core';
import { NetworkStatusStore } from '@resident-nx/web/util';
import { OfflineBannerComponent } from '../components/offline-banner/offline-banner.component';

@Injectable({
  providedIn: 'root',
})
class OfflineBannerService {
  #applicationRef = inject(ApplicationRef);
  #networkStatus = inject(NetworkStatusStore);
  #bannerRef?: ComponentRef<OfflineBannerComponent>;

  constructor() {
    effect(() => {
      if (this.#networkStatus.online()) {
        this.#destroyBanner();
      } else {
        this.#mountBanner();
      }
    });
  }

  #mountBanner(): void {
    if (this.#bannerRef) return;

    this.#bannerRef = createComponent(OfflineBannerComponent, {
      environmentInjector: this.#applicationRef.injector,
    });
    document.body.appendChild(this.#bannerRef.location.nativeElement);
    this.#applicationRef.attachView(this.#bannerRef.hostView);
  }

  #destroyBanner(): void {
    if (!this.#bannerRef) return;

    this.#applicationRef.detachView(this.#bannerRef.hostView);
    this.#bannerRef.destroy();
    this.#bannerRef = undefined;
  }
}

export const initializeOfflineBanner = () =>
  provideEnvironmentInitializer(() => inject(OfflineBannerService));
